import Axios from 'axios';
import { Subject } from '@/models/subject';
import { Tutor } from '@/modules/tutor';
import { Student } from '@/modules/student';
import { SchedulePerson } from '@/models/schedulePerson';
import { GradeYears } from '@/enums/gradeYears';
import moment from 'moment';

interface SearchCondition {
  perPage: number;
  page: number;
  sort: string;
  dateFrom: Date | null;
  dateTo: Date | null;
  keyword: string | null;
}

interface ReservableCount {
  seq: number;
  startDate: Date;
  endDate: Date;
  count: number;
  note: string;
}

// 型の Export
export {
  SearchCondition,
  ReservableCount,
};

interface State {
  isLoading: boolean;
  countAll: number;
  searchCondition: SearchCondition;
  list: ReservableCount[];
}

const mapState: State = {
  isLoading: false,
  countAll: 0,
  searchCondition: {
    perPage: 20,
    page: 1,
    sort: '',
    dateFrom: null,
    dateTo: null,
    keyword: null,
  },
  list: [],
};

const mapMutations = {
  setIsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },

  setList(state: State, list: ReservableCount[]) {
    state.list = list;
    state.isLoading = false;
  },

  setCountAll(state: State, countAll: number) {
    state.countAll = countAll;
  }
};

const mapActions = {
  async getListRequest({ commit, state }: { commit: any, state: State}) {
    commit('setIsLoading', true);

    const response = await Axios.post('/api/Reservation/ReservableCounts', state.searchCondition)
      .catch((error) => {
        commit('setList', []);
        throw error;
      });
    if (response) {
      const list = response.data.list;
      list.forEach((item: any) => {
        item.startDate = moment(item.startDate).toDate();
        item.endDate = moment(item.endDate).toDate();
      });
      commit('setList', list);
      commit('setCountAll', response.data.countAll);
    } else {
      commit('setList', []);
      commit('setCountAll', 0);
    }

    commit('setIsLoading', false);
  },

  async addRequest({ commit }: any, data: ReservableCount) {
    commit('setIsLoading', true);
    const response = await Axios.post('/api/Reservation/CreateReservableCount', data)
      .catch((error) => {
        commit('setIsLoading', false);
        throw error;
      });
    commit('setIsLoading', false);
    return true;
  },

  async editRequest({ commit }: any, data: ReservableCount) {
    commit('setIsLoading', true);
    const response = await Axios.post('/api/Reservation/EditReservableCount', data)
      .catch((error) => {
        commit('setIsLoading', false);
        throw error;
      });
    commit('setIsLoading', false);
    return true;
  },

  async removeRequest({ commit }: any, seq: number) {
    commit('setIsLoading', true);
    const response = await Axios.post('/api/Reservation/DeleteReservableCount', { seq })
      .catch((error) => {
        commit('setIsLoading', false);
        throw error;
      });
    commit('setIsLoading', false);
    return true;
  }
};

// ストアの Export
export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
